import { Paragraph } from '@sbab-ui/components'

interface Props {
  minAmount: number
  maxAmount: number
}

export default function Callout({ minAmount, maxAmount }: Readonly<Props>) {
  return (
    <div
      className="bg-[#f2f2f2] flex p-6 absolute z-20 w-full max-w-[678px] text-black"
      data-cy="calculation-error-msg"
    >
      <svg
        width="32"
        height="32"
        viewBox="0 0 64 64"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
        className="flex-shrink-0 self-center"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M27.6489 48.3288H37.5713V28.9146H27.6489V48.3288ZM31.9337 14.9278C35.0251 14.9278 37.5308 17.4292 37.5308 20.5148C37.5308 23.6005 35.0251 26.102 31.9337 26.102C28.8432 26.102 26.3372 23.6005 26.3372 20.5148C26.3372 17.4292 28.8432 14.9278 31.9337 14.9278V14.9278ZM51.259 5L11.75 5.73228L12.7414 59L52.2502 58.2671L51.259 5Z"
          fill="#FF620F"
        ></path>
      </svg>
      <Paragraph className="!pl-[10px] relative top-[2px] !mt-0">
        Välj ett belopp mellan {minAmount.toLocaleString('sv-SE')} -{' '}
        {maxAmount.toLocaleString('sv-SE')} kr för att få ett resultat.
      </Paragraph>
    </div>
  )
}
